<script setup>
import { ref, computed } from 'vue';
import map from 'lodash-es/map';
import { useQuery } from 'villus';
import { getClient } from '@/core/js/GraphqlClient.js';
import { useStore } from '@/store/Store.js';
import DiscountsListingCards from '@/components/discounts-listing/DiscountsListingCards.vue';

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    color: {
        type: String,
        default: '',
    },
    mainColor: {
        type: String,
        default: '',
    },
    themeColor: {
        type: String,
        default: '',
    },
    center: {
        type: Boolean,
        default: false,
    },
});
const store = useStore();
const client = getClient();
const groceries = ref([]);
const ingredientIds = ref([]);
const recipesQuantities = ref({});
const discounts = ref([]);

const variables = computed(() => ({
    lang: store.lang.value,
    relations: props?.data?.data?.categoryOrTag ? props?.data?.data?.categoryOrTag.map((item) => item.id) : null,
}));
if (props.data.data.categoryOrTag) {
    const { data: queryData } = await useQuery({
        variables,
        query: `
            query FetchDiscountsRelatedTo ($lang: [String], $relations: [QueryArgument]) {
                selectedDiscounts: entries(relatedTo: $relations, site: $lang, limit: 6, section: "discount") {
                    id
                    title,
                    status,
                    ... on discount_Entry {
                        prize: discountPrize,
                        unit: discountUnit,
                        url: discountUrl,
                        discountStatus: discountStatus,
                        ingredients: discountIngredients { id, slug, title },
                        grocery: discountGrocery {
                            ... on superStore_Entry {
                                id,
                                postDate,
                                title,
                                slug,
                                logo: groceryLogo {
                                    url @transform(format: "webp", quality: 80, width: 500, immediately: true)
                                }
                            },
                            ... on saleSpecialist_Entry {
                                id,
                                postDate,
                                title,
                                slug,
                                logo: groceryLogo {
                                    url @transform(format: "webp", quality: 80, width: 500, immediately: true)
                                }
                            },
                            ... on specializedGrocery_Entry {
                                id,
                                postDate,
                                title,
                                slug,
                                logo: groceryLogo {
                                    url @transform(format: "webp", quality: 80, width: 500, immediately: true)
                                }
                            }
                        }
                    }
                }
            }
        `,
    });

    discounts.value = queryData.value.selectedDiscounts;

    if (discounts.value && discounts.value.length > 0) {
        groceries.value = map(discounts.value, (disc) => disc.grocery[0]);
        groceries.value = Object.fromEntries(map(groceries.value, (groc) => [groc.id, groc]));

        /**
         * Get the count of recipes for each ingredient for further reference in the template
         */
        for (let i = 0, il = discounts.value.length; i < il; ++i) {
            ingredientIds.value = ingredientIds.value.concat(map(discounts.value[i].ingredients, (ing) => ing.id));
        }
        await Promise.all(
            ingredientIds.value.map(async (id) => {
                const { data: recipesCountData } = await client.executeQuery({
                    variables: {
                        lang: store.lang.value,
                        recipesIngredients: id,
                    },
                    query: `query FetchEntries($lang: [String], $recipesIngredients: [QueryArgument])  {
                    recipesCount: entryCount(section: "recette", site: $lang, relatedTo: $recipesIngredients)
                }`,
                });
                recipesQuantities.value[id] = recipesCountData.recipesCount;
            }),
        );
    }
}
</script>
<template>
    <div
        v-if="discounts && discounts.length"
        class="DiscountsRelatedTo px-6 xl:px-20"
    >
        <h2
            class="h2 mb-2 md:mb-10"
            :class="['text-dark-' + mainColor]"
        >
            {{ data.data.featuredContentTitle }}
        </h2>
        <DiscountsListingCards
            class="mb-4"
            :display-recipes-cta="true"
            :discounts="discounts"
            :groceries="groceries"
            :display-grocery-title="true"
            :recipes-quantities="recipesQuantities"
        />

        <div class="flex justify-center">
            <router-link
                class="HomeDiscounts__cta"
                :to="setUri({ uri: data.data.link[0].url })"
            >
                <Btn :text="data.data.link[0].text" />
            </router-link>
        </div>
    </div>
</template>
